import { Injectable } from '@angular/core';
import { ConsumeCredencialesService } from '../generico/servicio/consume-credenciales.service';
import { MensajeService } from '../generico/servicio/mensaje.service';
import { SpinnerService } from '../spinner.service';

@Injectable({
  providedIn: 'root'
})
export class MenuService {

  id_menu_padre : number;
  id_opcion_menu : number;
  menu : any = [];
  menu_padres : any = [];
  dialog_ref : any;
  menu_edit : any ; //mene a editar

  constructor(
    private cred_serv: ConsumeCredencialesService,
    private msjserv : MensajeService,
    private spin : SpinnerService,
  ) { }

  /**
   * Funcion que consulta los menus de una aplicacion 
   * @param data_form parametros para la consulta.
   */
  async consultar_menus(data_form){

    const promesa = this.cred_serv.post('obtenerMenus', data_form).toPromise();

    await promesa.then(
      (data : any )=>{
        this.spin.spin$.next(false);
        if(data.code > 0){
          this.msjserv.ver_mensaje(data.msg, '', this.msjserv.TIPO_ERROR);
        }else{

          this.menu = data.data.menu;

        }

      }
    );

  }

  /**
   * Funcion que consulta los menus de una aplicacion 
   * @param data_form parametros para la consulta.
   */
  async consultar_menus_padres(data_form){

    const promesa = this.cred_serv.post('obtenerMenus', data_form).toPromise();

    await promesa.then(
      (data : any )=>{
        this.spin.spin$.next(false);
        if(data.code > 0){
          this.msjserv.ver_mensaje(data.msg, '', this.msjserv.TIPO_ERROR);
        }else{

          this.menu_padres = data.data.menu;

        }

      }
    );

  }

  /**
   * Funcion que se encarga de crear un menu
   * @param data_form datos a registrar
   */
  gestionar_menu(data_form){
    this.cred_serv.post('gestionarMenu', data_form)
        .subscribe(
          (data:any)=>{
            this.spin.spin$.next(false);
            let tipo_mensaje = this.msjserv.TIPO_OK;

            if(data.code > 0){
              tipo_mensaje = this.msjserv.TIPO_ERROR;
            }

            this.msjserv.ver_mensaje(data.msg, '', tipo_mensaje)
                .afterClosed().subscribe(
                  ()=>{
                    if(data.code ==0){
                      this.dialog_ref.close();
                    }
                  }
                );
          }
        );
  }
}
